import { useQuery } from 'react-query';
import OrdersApi from '../../../OrdersApi';
import { FirmProduct } from '../types';

export function useFirmProductsQuery(brokerFirmId: number | null) {
    return useQuery<FirmProduct[]>(
        ['create-order-firm-products', brokerFirmId],
        () => OrdersApi.newOrderProducts(brokerFirmId as number),
        { enabled: brokerFirmId !== null, cacheTime: 0, refetchOnWindowFocus: false }
    );
}
